var pdpHelpers = require('./pdpHelpers');
var recetaHelpers = require('./recetaHelpers');
var albumBucketName = "ryk";
var bucketRegion = "us-east-2";
var IdentityPoolId = "us-east-2:a3aa72fb-190f-4e8a-9c87-fa3311eac5b1";

AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId,
  }),
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: albumBucketName },
});

function toggleAlert(ele, msg) {
  const device = $(window).width();

  if (device < 992 ) {
    //Mobile
    const element = '.'+ele;
    $('.alert.file-load').addClass(ele);
    $(element+' '+msg).removeClass('d-none');
    $(element).addClass('show');
    setTimeout(function() {
      $(element).removeClass('show');
      $(element+' '+msg).addClass('d-none');
      $(element).removeClass(ele);
    }, '2000');
  } else {
    // Desktop
    alert($(msg).html());
  }
}

$(document).on('change', "#carga-receta, #subscription-carga-receta, .carga-receta", function (e) {
  const acceptedExtensions = ["pdf", "jpg", "JPG", "jpeg", "JPEG", "png", "PNG"];
  const currentForm = pdpHelpers.resolveActiveTabSelector();
  let tipoProducto = $('[data-tipo-producto]').val();
  if (!tipoProducto || (tipoProducto && tipoProducto === 'null')) {
    tipoProducto = $(currentForm + ' [data-tipo-producto]').val();
  }
  const target = e.target || window.event.srcElement;
  const files = target.files;
  let albumName = "";

  if(tipoProducto === 'optica' || tipoProducto === 'sol') {
    albumName = "contact_emails_UY";
  }

  if (!files.length) {
    toggleAlert('alert-warning', 'span.warning');
  }

  var file = files[0];
  var fileName = file.name;
  var albumPhotosKey = encodeURIComponent(albumName) + "/Order/";
  var ext = fileName.substring(fileName.lastIndexOf(".") + 1);

  if (acceptedExtensions.includes(ext) ) {
    $(currentForm + ' #receta-file-name span').text(fileName);
    var now = new Date();
    var random_id = Math.floor(Math.random() * 10000 + 1);
    var photoKey = albumPhotosKey + "receta-"+recetaHelpers.formatDate(now)+"-" + random_id + "-ryk." + ext;

    s3.upload( {Key: photoKey, Body: file, ACL: "public-read"}
            , function (err, data) {
              if (err) {
                return alert("El archivo es demasiado grande por favor intente con uno mas liviano");
              }
              $(currentForm + ' .file-carga-receta').addClass('load');
              $('.carga-distancia-pupilar').addClass('load');

              toggleAlert('alert-success', 'span.success');

              sessionStorage.setItem("file-url", "https://ryk.s3.us-east-2.amazonaws.com/" + photoKey);

              $(currentForm + " [data-url-receta]").val("https://ryk.s3.us-east-2.amazonaws.com/" + photoKey);

              if(tipoProducto === 'lenteContacto') {
                recetaHelpers.verifyContactLens();
                recetaHelpers.erroQty(true);
              }

              recetaHelpers.canBeAddedToCart();

              if (pdpHelpers.isTabSuscriptionActive()) {
                pdpHelpers.validateSubscriptionEyeSelection();
              }
            }
    );
  } else {
    alert("Tipos de archivos aceptados png / jpg / pdf");
  }
});

$(document).on('change', ".configLensForm", function (e) {
  const currentForm = pdpHelpers.resolveActiveTabSelector();
  var tipoProducto = $('[data-tipo-producto]').val();
  if (!tipoProducto || (tipoProducto && tipoProducto === 'null')) {
    tipoProducto = $(currentForm + ' [data-tipo-producto]').val();
  }
  if(tipoProducto == 'lenteContacto') {
    recetaHelpers.verifyContactLens();
  };
});

$('input[name="diff"]').change(function () {
    const currentFormSelector = pdpHelpers.resolveActiveTabSelector();
    if ($(currentFormSelector + ' .same-formula').prop('checked')) {
      $(currentFormSelector + ' .same-formula-title').css('visibility', 'hidden');
      $(currentFormSelector + ' .diff-formula-column').addClass('d-none');
      $(currentFormSelector + ' .grid-lentes-config').css('grid-template-columns', '1.4fr 2fr 1fr');
      $(currentFormSelector + ' .receta-quant-right-eye').val($('.receta-quant-left-eye').val());
      $(currentFormSelector + ' [data-subtotal]').text(($('.receta-quant-left-eye').val() * 2) * parseInt($('[data-main-product-price]').text()));
    } else {
      $(currentFormSelector + ' .same-formula-title').css('visibility', 'visible');
      $(currentFormSelector + ' .diff-formula-column').removeClass('d-none');
      $(currentFormSelector + ' .grid-lentes-config').css('grid-template-columns', '1.4fr 2fr 2fr');
    }

    recetaHelpers.verifyContactLens();
});

function copyDataFromLeftEye(dataReceta) {
  dataReceta.DER_SKU_POS_LC = dataReceta.IZQ_SKU_POS_LC;
  dataReceta.DER_EJE_LEJOS = dataReceta.IZQ_EJE_LEJOS;
  dataReceta.DER_ESFERA = dataReceta.IZQ_ESFERA;
  dataReceta.DER_CURVA_BASE_LC = dataReceta.IZQ_CURVA_BASE_LC;
  dataReceta.DER_DIAMETRO_LC = dataReceta.IZQ_DIAMETRO_LC;
  dataReceta.DER_Poder_SPH = dataReceta.IZQ_Poder_SPH;
  dataReceta.DER_Curvatura = dataReceta.IZQ_Curvatura;
  dataReceta.DER_Diametro = dataReceta.IZQ_Diametro;
  dataReceta.DER_CILINDRO_LC = dataReceta.IZQ_CILINDRO_LC;
  return dataReceta;
}

function copyDataFromRightEye(dataReceta) {
  dataReceta.IZQ_SKU_POS_LC = dataReceta.DER_SKU_POS_LC;
  dataReceta.IZQ_EJE_LEJOS = dataReceta.DER_EJE_LEJOS;
  dataReceta.IZQ_ESFERA = dataReceta.DER_ESFERA;
  dataReceta.IZQ_CURVA_BASE_LC = dataReceta.DER_CURVA_BASE_LC;
  dataReceta.IZQ_DIAMETRO_LC = dataReceta.DER_DIAMETRO_LC;
  dataReceta.IZQ_Poder_SPH = dataReceta.DER_Poder_SPH;
  dataReceta.IZQ_Curvatura = dataReceta.DER_Curvatura;
  dataReceta.IZQ_Diametro = dataReceta.DER_Diametro;
  dataReceta.IZQ_CILINDRO_LC = dataReceta.DER_CILINDRO_LC;
  return dataReceta;
}

$('body').on('product:afterAddToCart', function (e, data) {
  if (!data.error) {
    // Reset form
    $('#nav-subscription .step1 input[value="bothEyesPlans"]').trigger('click');
    $('#nav-subscription .step1 input[value="bothEyesPlans"]').prop('checked', false);
    $('#nav-subscription .step1 input[value="singleEyePlans"]').prop('checked', false);

    $('#nav-subscription .step1dot1 input[value="left"]').prop('checked', false);
    $('#nav-subscription .step1dot1 input[value="right"]').prop('checked', false);
  }
});

$('body').on('updateAddToCartFormData', function (e, data) {
  const isSpecifyRecipe = $('#repite-receta-accordion2-header').attr('aria-expanded') === 'true';
  if (isSpecifyRecipe) {
    data.dataReceta = null;
    return;
  }

  let activeTabSelector = pdpHelpers.resolveActiveTabSelector();
  let dataUse = $(activeTabSelector + ' [data-use]').data('use');
  let dataReceta = null;

  try {
      if(dataUse) {
          dataReceta = $(activeTabSelector + ' [' + dataUse + ']').data('receta-completa');
      } else {
          dataReceta = $(activeTabSelector + ' [data-receta-completa]').data('receta-completa');
      }
  } catch(e) {}

  if (!dataReceta) {
    return;
  }

  if (data.selectedQuantityEyes === "bothEyesPlans" && data.tipoProducto === "lenteContacto") {
    var leftEyeSku = dataReceta.IZQ_SKU_POS_LC;
    var rightEyeSku = dataReceta.DER_SKU_POS_LC;
    if (rightEyeSku && leftEyeSku) {
      return;
    }

    if (rightEyeSku) {
        dataReceta = copyDataFromRightEye(dataReceta);
    }

    if (leftEyeSku) {
        dataReceta = copyDataFromLeftEye(dataReceta);
    }

    data.dataReceta = JSON.stringify(dataReceta);
  }

  if (data.selectedQuantityEyes === "singleEyePlans" && data.tipoProducto === "lenteContacto") {
        var leftEyeSku = dataReceta.IZQ_SKU_POS_LC;
        var rightEyeSku = dataReceta.DER_SKU_POS_LC;
        if (rightEyeSku && leftEyeSku) {
          return;
        }

        if (rightEyeSku && data.selectedEye === 'left') {
            dataReceta = copyDataFromRightEye(dataReceta);
        }

        if (leftEyeSku && data.selectedEye === 'right') {
          dataReceta = copyDataFromLeftEye(dataReceta);
      }

      data.dataReceta = JSON.stringify(dataReceta);
  }
});


$('.subscription-pdp .specify-diopter-section').on('shown.bs.collapse', function (ev) {
  pdpHelpers.validateOnEyeEyeSelection();
});

$(document).on('click', '.vision-type-option input', function(e) {
  $('.vision-type-option').removeClass('selected');
  $(e.currentTarget.parentElement).addClass('selected');
});